import { GET, POST, PUT, DELETE } from './core';

export const getAllLoyaltyPointRatios = (token, page = 0, pageSize = 25) =>
  GET(`/loyalty-point-ratio?page=${page}&pageSize=${pageSize}`, token);

export const searchLoyaltyPointRatios = (token, { ratioType, loyaltyTierId, page = 0, pageSize = 25 }) => {
  const params = new URLSearchParams({ page, pageSize });
  if (ratioType) params.append('ratioType', ratioType);
  if (loyaltyTierId) params.append('loyaltyTierId', loyaltyTierId);
  return GET(`/loyalty-point-ratio/search?${params.toString()}`, token);
};

export const getLoyaltyPointRatioById = (token, id) =>
  GET(`/loyalty-point-ratio/${id}`, token);

export const createLoyaltyPointRatio = (token, payload) =>
  POST('/loyalty-point-ratio/create', payload, token);

export const updateLoyaltyPointRatio = (token, payload) =>
  PUT('/loyalty-point-ratio/update', payload, token);

export const deleteLoyaltyPointRatio = (token, id) =>
  DELETE(`/loyalty-point-ratio/delete/${id}`, {}, token);
